import React, { createContext, useContext, useState, ReactNode } from 'react';

export enum AppType {
    LEGACY = 'LEGACY',
    HAUSARZT = 'HAUSARZT',
    KINDERARZT = 'KINDERARZT'
}

interface EnvironmentContextType {
    currentApp: AppType | null;
    setApp: (app: AppType) => void;
    clearApp: () => void;
}

const EnvironmentContext = createContext<EnvironmentContextType | undefined>(undefined);

export const EnvironmentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [currentApp, setCurrentApp] = useState<AppType | null>(() => {
        const storedApp = localStorage.getItem('currentApp');
        return storedApp ? (storedApp as AppType) : null;
    });

    const setApp = (app: AppType) => {
        setCurrentApp(app);
        localStorage.setItem('currentApp', app);
    };

    const clearApp = () => {
        setCurrentApp(null);
        localStorage.removeItem('currentApp');
    };

    // Optional: Sync across tabs if needed, but basic localStorage is fine for now.

    return (
        <EnvironmentContext.Provider value={{ currentApp, setApp, clearApp }}>
            {children}
        </EnvironmentContext.Provider>
    );
};

export const useEnvironment = () => {
    const context = useContext(EnvironmentContext);
    if (!context) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};
